// extracted by mini-css-extract-plugin
export default {"container":"Zv-z","brandName":"_v-z","productName":"aw-z","productNamePdpEnhancements":"bw-z","breakLongProductName":"cw-z"};